import React from 'react';
import { Table } from 'react-bootstrap';
import './TableSkeleton.scss';

function TableSkeleton({ columns = 8, rows = 5 }) {
  return (
    <Table responsive>
      <thead>
        <tr>
          {[...Array(columns)].map((_, i) => (
            <th key={i}>
              <div className="skeleton-cell" style={{ width: '80%', height: '24px' }} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...Array(rows)].map((_, rowIndex) => (
          <tr key={rowIndex}>
            {[...Array(columns)].map((_, colIndex) => (
              <td key={colIndex}>
                <div 
                  className="skeleton-cell"
                  style={{ 
                    width: `${Math.random() * 40 + 40}%`,
                    height: '20px'
                  }} 
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default TableSkeleton; 